module.exports = __webpack_public_path__ + "img/xz-logo.5bf329d7.png";